import { render, staticRenderFns } from "./AudioScrollbar.vue?vue&type=template&id=796007cd&scoped=true"
import script from "./AudioScrollbar.vue?vue&type=script&lang=js"
export * from "./AudioScrollbar.vue?vue&type=script&lang=js"
import style0 from "./AudioScrollbar.vue?vue&type=style&index=0&id=796007cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796007cd",
  null
  
)

export default component.exports